export default "__VITE_ASSET__CAs_GXwT__"